import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import {
  toggleProvider,
  togglePayer,
  toggleMyAccount,
  toggleNavItem,
} from './actions';

const headerMenuSelector = (state) => state.headerMenu;

export const useHeaderMenu = {
  state: () => {
    return useSelect(headerMenuSelector);
  },
  actions: () => {
    return {
      togglePayer: useAction(togglePayer),
      toggleProvider: useAction(toggleProvider),
      toggleMyAccount: useAction(toggleMyAccount),
      toggleNavItem: useAction(toggleNavItem),
    };
  },
};
